import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white pt-16 pb-8" data-id="element-35">
      <div className="container mx-auto px-4" data-id="element-36">
        <div className="grid md:grid-cols-4 gap-8 mb-12" data-id="element-37">
          <div data-id="element-38">
            <div className="flex items-center mb-4" data-id="element-39">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vwP82zAyS5YTdoZq7T5QTk/Screenshot_20250729-220251_Google.jpg" alt="MimiApp Logo" className="h-8 w-auto mr-2" data-id="element-40" />
              <h3 className="text-xl font-bold" data-id="element-41">MimiApp</h3>
            </div>
            <p className="text-gray-400 mb-4" data-id="element-42">
              Mental wellness designed for young Africans. Healing. Together. On
              your terms.
            </p>
            <div className="flex space-x-4" data-id="element-43">
              <a href="#" className="text-gray-400 hover:text-white" data-id="element-44">
                <FacebookIcon size={20} data-id="element-45" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white" data-id="element-46">
                <TwitterIcon size={20} data-id="element-47" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white" data-id="element-48">
                <InstagramIcon size={20} data-id="element-49" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white" data-id="element-50">
                <LinkedinIcon size={20} data-id="element-51" />
              </a>
            </div>
          </div>
          <div data-id="element-52">
            <h4 className="text-lg font-medium mb-4" data-id="element-53">App</h4>
            <ul className="space-y-2" data-id="element-54">
              <li data-id="element-55">
                <a href="#features" className="text-gray-400 hover:text-white" data-id="element-56">
                  Features
                </a>
              </li>
              <li data-id="element-57">
                <a href="#testimonials" className="text-gray-400 hover:text-white" data-id="element-58">
                  Testimonials
                </a>
              </li>
              <li data-id="element-59">
                <a href="#pricing" className="text-gray-400 hover:text-white" data-id="element-60">
                  Pricing
                </a>
              </li>
              <li data-id="element-61">
                <a href="#" className="text-gray-400 hover:text-white" data-id="element-62">
                  Download
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-63">
            <h4 className="text-lg font-medium mb-4" data-id="element-64">Support</h4>
            <ul className="space-y-2" data-id="element-65">
              <li data-id="element-66">
                <a href="#" className="text-gray-400 hover:text-white" data-id="element-67">
                  Crisis Help
                </a>
              </li>
              <li data-id="element-68">
                <a href="#" className="text-gray-400 hover:text-white" data-id="element-69">
                  Find a Therapist
                </a>
              </li>
              <li data-id="element-70">
                <a href="#" className="text-gray-400 hover:text-white" data-id="element-71">
                  FAQs
                </a>
              </li>
              <li data-id="element-72">
                <a href="#" className="text-gray-400 hover:text-white" data-id="element-73">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-74">
            <h4 className="text-lg font-medium mb-4" data-id="element-75">Legal</h4>
            <ul className="space-y-2" data-id="element-76">
              <li data-id="element-77">
                <a href="#" className="text-gray-400 hover:text-white" data-id="element-78">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-79">
                <a href="#" className="text-gray-400 hover:text-white" data-id="element-80">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-81">
                <a href="#" className="text-gray-400 hover:text-white" data-id="element-82">
                  Cookie Policy
                </a>
              </li>
              <li data-id="element-83">
                <a href="#" className="text-gray-400 hover:text-white" data-id="element-84">
                  Data Protection
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 mt-8 text-center text-gray-500 text-sm" data-id="element-85">
          <p data-id="element-86">© {new Date().getFullYear()} MimiApp. All rights reserved.</p>
          <p className="mt-2" data-id="element-87">
            MimiApp is not a replacement for professional mental health
            treatment. If you're experiencing a crisis, please contact emergency
            services.
          </p>
        </div>
      </div>
    </footer>;
}